/* cart-drawer.js — drawer обновляется, но НЕ открывается сам
   (18‑04‑2025) */

const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  }
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    /* закрыть по Esc */
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    /* закрыть по оверлею */
    this.querySelector('#CartDrawer-Overlay')
        .addEventListener('click', this.close.bind(this));

    /* привязать к ссылке/иконке корзины */
    this.setCartLink();

    /* в Theme Editor открывать/закрывать */
    this.parentElement.addEventListener('shopify:section:select',   () => this.open());
    this.parentElement.addEventListener('shopify:section:deselect', () => this.close());
  }

  /* ————————————————————
     привязываем к элементу с data-cart-link
     ———————————————————— */
  setCartLink() {
    const cartLink = document.querySelector('[data-cart-link]');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (e) => {
      e.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (e) => {
      if (e.code.toUpperCase() !== 'SPACE') return;
      e.preventDefault();
      this.open(cartLink);
    });
  }

  /* ————————————————————
     ОТКРЫТЬ drawer (вызывается вручную)
     ———————————————————— */
  open(opener) {
    if (opener) this.setActiveElement(opener);

    this.classList.add('is-visible');
    this.querySelector('.cart-drawer__inner')
        .setAttribute('aria-hidden', 'false');

    /* фокус после анимации */
    this.addEventListener(
      'transitionend',
      () => this.focusOnCartDrawer(),
      { once: true }
    );

    bodyScroll.lock(this.querySelector('[role="dialog"]'));

    /* спрячем product‑bar, если есть */
    const productBar = document.querySelector('product-bar');
    if (productBar) productBar.style.opacity = '0';
  }

  /* ————————————————————
     ЗАКРЫТЬ drawer
     ———————————————————— */
  close() {
    this.classList.remove('is-visible');
    removeTrapFocus(this.activeElement);

    /* если открыто меню в хэдере — не разблокируем скролл */
    const isHeaderMenuOpen = header.classList.contains('menu-open');
    if (!isHeaderMenuOpen) {
      bodyScroll.unlock(this.querySelector('[role="dialog"]'));
    }

    /* если мы на /cart, пересчитаем summary */
    if (window.location.pathname === '/cart') {
      const summaryForm = document.getElementById('CartDrawer-FormSummary');
      summaryForm?.submit();
    }

    const productBar = document.querySelector('product-bar');
    if (productBar) productBar.removeAttribute('style');
  }

  /* сохраняем, куда вернёмся фокусом */
  setActiveElement(element) {
    this.activeElement = element;
  }

  /* ————————————————————
     РЕНДЕРИТЬ контент секций
     (❗ НЕ открывает drawer автоматически)
     ———————————————————— */
  renderContents(response) {
    this.getSectionsToRender().forEach((section) => {
      const container = document.querySelector(section.id);
      if (!container) return;

      container.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );
    });

    /* ▸ раньше здесь было this.open();
       ▸ удалено, чтобы drawer не открывался сам */
  }

  /* какие секции обновлять */
  getSectionsToRender() {
    return sectionsToRender;
  }

  /* вытаскиваем HTML нужного селектора из ответа */
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  /* фокусируемся внутри drawer */
  focusOnCartDrawer() {
    const drawer = this.querySelector('.cart-drawer');
    drawer?.focus();
  }
}

customElements.define('cart-drawer', CartDrawer);

/* ————————————————————
   Класс элементов внутри drawer
   ———————————————————— */
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

